<script setup>
  import { useValidaForm } from '@js/vue/stores/useValidaForm.js';

  const fichaValidate = useValidaForm()

  const props = defineProps({
    route: String,
  });
</script>

<template>
  <a :href="route" :class="fichaValidate.countObrigatorio != fichaValidate.countPreenchidos && `pointer-events-none`">
    <v-button class="!flex gap-2 itens-center" type="button" :disabled="fichaValidate.countObrigatorio != fichaValidate.countPreenchidos">
      <v-icon iconify="mingcute:send-plane-line" class="text-2xl"></v-icon>
      Enviar
    </v-button>
  </a>
</template>
